import React, { useEffect } from "react"
import { store } from "@/store"
import Button from "@/components/core/Button/Button"
import { toggleSiteWideWarning } from "@/store/features/genericSlice"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import styles from "@/components/ProductDetail/v3/CatalogCTA/index.module.scss"
import toolTipIcon from "@/public/icons/tooltip-red.svg"

const CatalogCTA = ({
  sku = "",
  config = {},
  isSoldOnline,
  isDiscontinued,
  productName = "",
  staticTexts: label,
  redirectUrl = "",
  inriverId = "",
}) => {
  const {
    general: { findStorePagePath = "/", productEnquiryPath = "/" } = {},
  } = config

  useEffect(() => {
    store.dispatch(toggleSiteWideWarning())
  }, [])

  const handleAnalytics = (ctaName, ctaLink, internalLink = true) => {
    const link = ctaLink
      ? (ctaLink.indexOf("http") === -1 ? window.location.origin : "") + ctaLink
      : "n/a"
    const eventInfo = {
      clickInternalLinks: internalLink ? "true" : "false",
      eventAction: `pdp:product details:${ctaName}`,
      eventName: `pdp:product details:${ctaName}`,
      eventType: "navigation",
      internalLinkName: ctaName,
      internalLinkPosition: "pdp",
      internalLinkType: `pdp:navigation`,
      internalLinkZoneName: `pdp:product details`,
      internalLinkURL: link,
    }
    pushAnalyticsObjToDataLayer(eventInfo)
  }

  return (
    <div className={styles.catalogCtaWrapper}>
      <div className="catalog-ctas">
        {isDiscontinued ? (
          <div className="catalog-discontinued">
            <img src={toolTipIcon.src} alt="" />
            <p>{label.brandsDiscontinuedMsg}</p>
          </div>
        ) : redirectUrl ? (
          <Button
            to={redirectUrl}
            role="link"
            ariaLabel={label.shopKohler}
            label={label.shopKohler}
            size="large"
            type="primary"
            flexible={true}
            className="catalog-btn"
            onClick={() => handleAnalytics("shop kohler", redirectUrl, false)}
          />
        ) : (
          <div className="catalog-enquiry-ctas">
            <div className="cta">
              <Button
                role="link"
                label={label.productEnquiry}
                size="large"
                type="black"
                to={`${productEnquiryPath}?sku=${sku}&pname=${productName}&id=${inriverId}`}
                target="_blank"
                className="catalog-btn"
                flexible
                onClick={() =>
                  handleAnalytics(
                    "product enquiry",
                    `${productEnquiryPath}?sku=${sku}&pname=${productName}&id=${inriverId}`
                  )
                }
              />
            </div>
            {isSoldOnline !== false && (
              <div className="cta">
                <Button
                  role="link"
                  label={label.findStore}
                  size="large"
                  type="ghost"
                  to={findStorePagePath}
                  target="_blank"
                  className="catalog-btn"
                  flexible
                  onClick={() =>
                    handleAnalytics("find a store", findStorePagePath)
                  }
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CatalogCTA
